import ResultPopup from "./index.vue";
import Vue, {VueConstructor} from "vue";
import {mergeOptions} from "@/core/plugin_helper";

let $vm: any

interface ConfirmOptions {
    onConfirm?: () => unknown;
    onCancel?: () => void;
    companyId?: string;
    mobile?: string;
    routeName?: string;
}

const install = (vue: VueConstructor, options = {}) => {
    let ResultPopupConstructor = vue.extend(ResultPopup)

    if (!$vm) {
        $vm = new ResultPopupConstructor({
            el: document.createElement('div'),
            propsData: {
                title: ''
            }
        })
        document.body.appendChild($vm.$el)
    }
    const confirm = {
        async show (options: ConfirmOptions) {

            $vm.companyId = options.companyId
            $vm.mobile = options.mobile
            $vm.routeName = options.routeName
            console.log($vm,'===================');
            await $vm.getNode($vm)
            $vm.getSign()
            // if (Object.keys($vm.noteInfo).length && window.localStorage.getItem('isConfirm') !== '1') {
            if (Object.keys($vm.noteInfo).length) {
                $vm.showResult = true
            }

            if (typeof options === 'object') {
                mergeOptions($vm, options)
            }
            $vm.$off('on-cancel')
            $vm.$off('on-confirm')
            $vm.$on('on-cancel', () => {
                options && options.onCancel && options.onCancel()
                $vm.showResult = false
            })
            $vm.$on('on-confirm', () => {
                if (options && options.onConfirm) {
                    const res = options.onConfirm()
                    if (res instanceof Promise) {
                        res.then(() => {
                            $vm.showResult = false
                        })
                    } else {
                        $vm.showResult = false
                    }
                }
            })
        },
    }
    Object.defineProperty(vue.prototype, '$resultPopup', {
        value: confirm
    })
}

Vue.use(install)

export default install
